import React, { useEffect } from 'react';
import { flow } from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as ToastsSelectors from '../../selectors/toasts';
import * as QueueSelectors from '../../selectors/queue';
import { FaviconController } from '../../../../../../FaviconController';
import { REALTIME_NOTIFICATION_LOG_MODULE } from '../../../../../shared/constants';
import { SafeComponent } from '../../../../../../shared/SafeComponent';

function _Favicon({ isActive }) {
    return isActive ? <DecoratedFavicon /> : <DefaultFavicon />;
}

_Favicon.propTypes = {
    isActive: PropTypes.bool.isRequired,
};

function DefaultFavicon() {
    useEffect(() => {
        FaviconController.reset();
    }, []);

    return null;
}

function DecoratedFavicon() {
    useEffect(() => {
        FaviconController.decorate();
    }, []);

    return null;
}

const mapStateToProps = (state) => {
    const isActive = !QueueSelectors.isEmpty(state) || !ToastsSelectors.isEmpty(state);

    return {
        isActive,
    };
};

export const Favicon = flow(
    connect(mapStateToProps),
    SafeComponent(REALTIME_NOTIFICATION_LOG_MODULE, 'Favicon')
)(_Favicon);
